export const CROPPED_TEXT_BUTTON_MORE = 'View more';
export const CROPPED_TEXT_BUTTON_LESS = 'View less';
